export function buildGradientString(stops,angle){if(!stops||!stops.length||stops.length<2)return"";const normalized=stops.map(s=>(`${s.color} ${s.position}%`)).join(",");return`linear-gradient(${angle||90}deg, ${normalized})`;}

export function animationCSS(s){
  if(!s.animation||s.animation==="none")return"none";
  const duration=(s.animationDuration||0.6);
  const delay=(s.animationDelay||0);
  const timing=(s.animationTiming||"ease-in-out");
  return `${s.animation} ${duration}s ${timing} ${delay}s forwards`;
}

export function shadowCSS(s){if(!s.shadowBlur&&!s.shadowX&&!s.shadowY)return"none";return`${s.shadowX||0}px ${s.shadowY||0}px ${s.shadowBlur||0}px ${s.shadowColor||"#00000044"}`;}

export function getLooseObjectValue(obj,key){
  if(!obj||typeof obj!=="object")return undefined;
  if(key in obj)return obj[key];
  const trimmed=String(key).trim();
  if(trimmed&&trimmed in obj)return obj[trimmed];
  const lower=trimmed.toLowerCase();
  const hit=Object.keys(obj).find(k=>String(k).trim().toLowerCase()===lower);
  return hit!=null?obj[hit]:undefined;
}

export function resolveDataValue(key,data){if(!key||data==null)return undefined;try{if(typeof data==="object"&&data!==null){const direct=getLooseObjectValue(data,key);if(direct!==undefined)return direct;}const tokens=String(key).replace(/\[(\d+)\]/g,".$1").split(".").filter(Boolean);let val=data;for(const tok of tokens){if(val==null)return undefined;val=(typeof val==="object"&&val!==null)?getLooseObjectValue(val,tok):val[tok];}return val;}catch{return undefined;}}

export function bgCSS(s,data){const imageKey=typeof s.backgroundImageKey==="string"?s.backgroundImageKey.trim():"";if(imageKey&&data!=null){const resolved=resolveDataValue(imageKey,data);if(resolved!=null&&resolved!=="")return `url(${resolved}) center/cover`;}
 if(s.backgroundImage) return `url(${s.backgroundImage}) center/cover`; if(s.gradientEnabled&&s.gradientStops&&s.gradientStops.length>=2) return buildGradientString(s.gradientStops,s.gradientAngle); if(s.gradientEnabled&&s.gradientFrom&&s.gradientTo) return `linear-gradient(${s.gradientAngle||135}deg,${s.gradientFrom},${s.gradientTo})`; return s.backgroundColor||"transparent";}

export const HIDE_SCROLLBAR_CSS=`.kiosk-hs{scrollbar-width:none!important;-ms-overflow-style:none!important}.kiosk-hs::-webkit-scrollbar{display:none!important}`;

 export function bgStyleObj(s, dataCtx) {
  const imageKey = typeof s.backgroundImageKey === "string" ? s.backgroundImageKey.trim() : "";
  if (imageKey && dataCtx != null) {
    const resolved = resolveDataValue(imageKey, dataCtx);
    if (resolved != null && resolved !== "")
      return { backgroundImage: `url(${resolved})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" };
  }
  if (s.backgroundImage && s.backgroundImage.trim() !== "")
    return { backgroundImage: `url(${s.backgroundImage})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" };
  if (s.gradientEnabled && s.gradientFrom && s.gradientTo)
    return { background: `linear-gradient(${s.gradientAngle || 135}deg, ${s.gradientFrom}, ${s.gradientTo})` };
  return { backgroundColor: s.backgroundColor || "transparent" };
}